import { render, staticRenderFns } from "./AditionalsPrice.vue?vue&type=template&id=fb2b4cee"
import script from "./AditionalsPrice.vue?vue&type=script&lang=js"
export * from "./AditionalsPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports